<template>
	<div>
		<el-dialog :visible.sync="showupdateweight" title="称重" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false">
			<div class="updateweight" style="height:200px" align="center">
				<table class="htmltable">
					<tr>
						<td>
							<span>单 号</span>
						</td>
						<td>
							<el-input v-model="p_pkval" :disabled="dispkval" type="text" ref="p_pkval" @keyup.native="val => enterinput(val,'weight')"></el-input>
						</td>
					</tr>
					<tr><td colspan="2"></td></tr>
					<tr>
						<td><span>重  量</span></td>
						<td>
							<el-input :disabled="disweight" v-model="weight" type="text" ref="weight" @keyup.native="val => enterinput(val,'')"></el-input>
						</td>
					</tr>
					<tr>
						<td colspan="4" class="tips">
							<span>已称重 {{count}} 单</span>
						</td>
					</tr>
				</table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
	},
	data() {
		return {
			showupdateweight: false, //弹窗显示,
			p_pkval:'',
			weight:'',
			divclass:'updateweight',
			dispkval:false,
			disweight:false,
			count:0,
			currentpkval:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/logisticsmanager/updateweight_xnd.scss');
		});
		if (this.curpkval!='') this.p_pkval =this.curpkval;
		this.currentpkval=this.p_pkval;
	},
	methods: {
		init(param){
			var that=this;
			this.showupdateweight=true;
			if(param!=undefined){
				if(param.pkval!=undefined){
					this.p_pkval=param.pkval;
					this.currentpkval=this.p_pkval;
				}
			}
			setTimeout(function() {
				if(that.p_pkval!='')
				{
					if(that.$refs.weight!=undefined)
						that.$refs.weight.focus();
				}
				else{
					if(that.$refs.p_pkval!=undefined)
						that.$refs.p_pkval.focus();
				}
			}, 200);
		},
		enterinput(event,next){
			if (event.keyCode != undefined) {
				if (event.keyCode == 13) {
					if(next!=''){
						if(this.p_pkval!=''){
							this.CheckOrderPkval();
						}
					}
					else
						this.updateweight();
				}
			}
		},
		//检测订单
		CheckOrderPkval(){
			var that=this;
			this.$tool.loading('正在验证订单', this.divclass);
			this.dispkval=true;
			this.disweight=true;
			this.$apipost.get.CheckOrderPkval({pkval:this.p_pkval}).then(res => {
				this.$tool.loadingclose();
				this.dispkval=false;
				this.disweight=false;
				if (res != '') {
					if(res.state=='1'){
						that.currentpkval=res.pkval;
						setTimeout(function(){
							that.$refs.weight.focus();
						},50);
					}else{
						that.currentpkval='';
						that.p_pkval='';
						that.weight='';
						this.$tool.message(res.message, 0);
						setTimeout(function(){that.$refs.p_pkval.focus();},50);
					}
				}
			});
		},
		//更新重量
		updateweight(){
			var that=this;
			if(this.weight==''||this.p_pkval==''||this.currentpkval==''){
				return false;
			}
			this.dispkval=true;
			this.disweight=true;
		
			this.$apipost.post.UpdateWeight_xnd({pkval:this.currentpkval,weight:this.weight}).then(res => {
				this.dispkval=false;
				this.disweight=false;
				if (res != '') {
					if(res.state=='1'){
						this.$tool.message('操作成功', 1);
						that.p_pkval='';
						that.currentpkval='';
						that.weight='';
						that.count=that.count+1;
						setTimeout(function(){that.$refs.p_pkval.focus();},50);
					}else{
						setTimeout(function(){
							that.$refs.weight.focus();
						},50);
						this.$tool.message(res.message, 0);
					}
				}else
				{
					setTimeout(function(){
						that.$refs.weight.focus();
					},50);
					this.$tool.message('操作异常', 0);
				}
			});
		}
	},
}
</script>

<style>
</style>
